import moment from "moment";


export const getTripType = (trip_start_datetime, trip_length_in_seconds, is_bespoke) => {
    // a function to decide if a trip is Active, Past, Upcoming or Nonbespoke
    if (!is_bespoke) {
        // Non-bespoke trips
        return 3;
    }

    const now = moment.utc(); // Current time in UTC
    const start_datetime = moment.utc(trip_start_datetime); // Trip start datetime in UTC
    // Assuming 'length' represents milliseconds for the duration of the trip
    const trip_end = start_datetime.clone().add(trip_length_in_seconds, 'seconds'); // Calculate trip end based on duration

    // Past trips
    if (now.isAfter(trip_end.add(1, 'day'))) {
        return 2;
    }

    // Future trips
    if (now.isBefore(start_datetime)) {
        return 1;
    }

    // Active trips
    if (now.isAfter(start_datetime) && now.isBefore(trip_end)) {
        return 0;
    }

    // Fallback for any unhandled case
    return 0;
};